import { render, staticRenderFns } from "./EditEmailTemplate.vue?vue&type=template&id=c1789a4a&scoped=true"
import script from "./EditEmailTemplate.vue?vue&type=script&lang=js"
export * from "./EditEmailTemplate.vue?vue&type=script&lang=js"
import style0 from "./EditEmailTemplate.vue?vue&type=style&index=0&id=c1789a4a&prod&lang=scss&scoped=true"
import style1 from "./EditEmailTemplate.vue?vue&type=style&index=1&id=c1789a4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1789a4a",
  null
  
)

export default component.exports